var app = angular.module("leonardo");

var TaskAssignDialog = function($scope, $rootScope, accountUsers, AccountUserService, TemplateService,
                                TemplateWorkflowService, TaskService, FilterService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.template = $scope.ngDialogData.template;
  $scope.work_order = $scope.ngDialogData.work_order;
  $scope.action = $scope.ngDialogData.action;
  $scope.accountUsers = accountUsers.results ? accountUsers.results : accountUsers;
  $scope.account_users = [];

  $scope.taskService = TaskService;
  $scope.templateService = TemplateService;

  $scope.setDefaultValues = function() {
    var account_users = ($scope.action === 'template') ? $scope.template.account_users_assigned : $scope.task.account_users_assigned;
    angular.forEach(account_users, function(value){
      $scope.account_users.push(value.id);
    });
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      return;
    }
    if (!angular.isArray($scope.account_users)){
      if (!$scope.account_users || $scope.account_users.length === 0) {
        $scope.account_users = [];
      }
      else {
        $scope.account_users = $scope.account_users.split(',');
      }
    }
    if (($scope.action === 'template') || $scope.set_to_template){
      if ($scope.task.type_task == TaskService.TYPE_TASK_WORKFLOW) {
        $scope.template.assignUsers({account_users_assigned: $scope.account_users}).then(function(data) {
          $scope.confirm(data);
        });
      }
      else {
        var params = {
          account_users_assigned: $scope.account_users,
          // portfolios: portfolios,
          properties: [FilterService.getFilter('property')],
          set_to_template: $scope.set_to_template
        };
        $scope.template.assignUsers(params).then(function(data) {
          $scope.confirm(data);
        });
      }
    }
    else {
      $scope.task.assignUsers({
        account_users_assigned: $scope.account_users,
        set_to_template: $scope.set_to_template
      }).then(function(data) {
        $scope.confirm(data);
      });
    }
  };

  $scope.setDefaultValues();

};

app.controller('TaskAssignDialog', ['$scope', '$rootScope', 'accountUsers', 'AccountUserService', 'TemplateService',
  'TemplateWorkflowService', 'TaskService', 'FilterService', TaskAssignDialog]);
